import { Box, TextField, Grid, MenuItem } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

const TIMEZONES = [
  { value: 'America/New_York', label: 'Eastern Time (ET)' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Phoenix', label: 'Mountain Time - Arizona (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (HT)' },
];

const BasicInformationForm = ({ competition, onUpdate }) => {
  const handleChange = (field) => (event) => {
    onUpdate({
      ...competition,
      [field]: event.target.value
    });
  };


  return (
    <Box sx={{ mt: 4 }} data-ui="form-basic-info">
      <TextField
        data-ui="form-basic-info-name"
        fullWidth
        label="Competition Name"
        value={competition.name}
        onChange={handleChange('name')}
        sx={{ mb: 3 }}
      />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <DatePicker
            data-ui="form-basic-info-start-date"
            label="Start Date"
            value={competition.startDate ? new Date(competition.startDate) : null}
            onChange={(newValue) => {
              onUpdate({
                ...competition,
                startDate: newValue
              });
            }}
            slotProps={{ textField: { fullWidth: true } }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DatePicker
            data-ui="form-basic-info-end-date"
            label="End Date"
            value={competition.endDate ? new Date(competition.endDate) : null}
            onChange={(newValue) => {
              onUpdate({
                ...competition,
                endDate: newValue
              });
            }}
            slotProps={{ textField: { fullWidth: true } }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            data-ui="form-basic-info-venue"
            fullWidth
            label="Venue"
            value={competition.facility || ''}
            onChange={handleChange('facility')}
            placeholder="Enter venue name and address"
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            data-ui="form-basic-info-timezone"
            select
            fullWidth
            label="Time Zone"
            value={competition.timezone || 'America/New_York'}
            onChange={handleChange('timezone')}
            helperText="Select the time zone for this competition"
          >
            {TIMEZONES.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>

      <TextField
        data-ui="form-basic-info-details"
        fullWidth
        multiline
        rows={3}
        label="Competition Details"
        value={competition.details || ''}
        onChange={handleChange('details')}
        sx={{ mt: 3 }}
        placeholder="Enter any additional details about the competition"
      />
    </Box>
  );
};

export default BasicInformationForm;
